import React from "react";

// "Materials & brands we can work with" — neutral wording
const BRANDS_ROW1 = [
    { name: "Jaguar", color: "#0C8C3A" },
    { name: "Saint-Gobain", color: "#0E4DA4" },
    { name: "Kohler", color: "#111111" },
    { name: "Bosch", color: "#E2231A" },
    { name: "Siemens", color: "#009999" },
    { name: "Hettich", color: "#111111" },
];
const BRANDS_ROW2 = [
    { name: "Greenlam", color: "#1E8E3E" },
    { name: "Samsung", color: "#1428A0" },
    { name: "Häfele", color: "#111111" },
    { name: "Jotun", color: "#111111" },
    { name: "LG", color: "#A50034" },
    { name: "Grohe", color: "#111111" },
];

function Logo({ b }) {
    return (
        <div className="flex h-24 items-center justify-center rounded-2xl bg-white border border-black/10 card-lift">
            <span className="font-display text-xl sm:text-2xl font-extrabold tracking-tight" style={{ color: b.color }}>
                {b.name}
            </span>
        </div>
    );
}

export default function TrustedPartners() {
    return (
        <section className="bg-[#F5F5F5] py-16 sm:py-20">
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <div className="text-center fade-up">
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[52px] font-extrabold tracking-[-0.03em]">
                        Materials &amp; brands we can work with
                    </h2>
                    <p className="mt-4 text-sm text-black/60 max-w-2xl mx-auto">
                        We source and work with trusted material, furniture, lighting and hardware brands based on your design, project requirements and budget.
                    </p>
                </div>

                <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-5">
                    {BRANDS_ROW1.map((b) => <Logo key={b.name} b={b} />)}
                </div>
                <div className="mt-4 sm:mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-5">
                    {BRANDS_ROW2.map((b) => <Logo key={b.name} b={b} />)}
                </div>

                <div className="mt-8 flex justify-center">
                    <span className="inline-flex items-center gap-2 rounded-full bg-[#E7FF66] px-5 py-2 text-sm font-bold text-black">
                        <span className="text-lg leading-none">+</span>
                        Premium materials. Better finish. Peace of mind.
                    </span>
                </div>
            </div>
        </section>
    );
}
